import React, { useEffect, useState } from "react";
import MainLayout from "../../layout";
import DeleteModal from "../../components/modal/delete-modal";
import ShareModal from "../../components/modal/share-modal";
import { Link, useNavigate, useParams } from "react-router-dom";
import { TextView } from "../../components/view-form-components/text-view";
import CommentsComponent from "../../components/comments/comments";
import FileCommentComponent from "../../components/comments/file-comment";
import { useRole } from "../../context/role/RoleContext";
import { api } from "../../redux/apis/api";
import moment from "moment";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { FormImageField } from "../../components/form/image";
import successToast from "../../components/toast/successToast";
import errorToast from "../../components/toast/errorToast";
import InvoiceModal from "./Invoice";
import StandardInvoiceModal from "./standard-invoice";
import DeliveryInvoiceModal from "./delivery-invoice";
import CustomerPaymentCreateModal from "../../components/customer-components/customer-payment/customer-payment-create-modal";

const ViewOrders = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { state } = useRole();
  const permission = state?.role?.order;
  const paymentPermission = state?.role?.payment;
  const [data, setData] = useState();
  const [paymentData, setPaymentData] = useState();
  const [loading, setLoading] = useState(true);
  const [deleteModalShow, setdeleteModalShow] = useState(false);
  const [shareModalShow, setShareModalShow] = useState(false);
  const [printModalShow, setPrintModalShow] = useState(false);
  const [invoiceModalShow, setInvoiceModalShow] = useState(false);
  const [deliveryModalShow, setDeliveryModalShow] = useState(false);
  const [createModal, setcreateModal] = useState(false);

  const initialValues = {
    id: params?.id,
    url: data?.order?.delivered_photo ?? "",
  };

  const validationSchema = Yup.object().shape({});

  const handleSubmit = (values) => {
    api
      .post(`/order/update-delivery-image`, values)
      .then((res) => {
        successToast(res.message);
      })
      .catch((err) => {
        console.error("API Error:", err);
        errorToast(err?.response?.data?.message);
      });
  };

  const fetchData = () => {
    setLoading(true);
    api
      .post(`/order/read`, {
        id: params?.id,
      })
      .then((res) => {
        setData(res.data.data);
        setPaymentData([...res.data.data.payments]);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (params?.id) {
      fetchData();
    }
  }, [params?.id]);

  const deleteFnc = (id) => {
    api
      .post(`/order/delete`, {
        id: id,
      })
      .then((res) => {
        setData(res.data.data);
        // setLoading(false);
        navigate("/orders/list");
        // fetchData();
      })
      .catch((err) => {
        console.error("API Error:", err);
        // setLoading(false);
      });
  };

  console.log(data, "data");

  return (
    <MainLayout>
      <CustomerPaymentCreateModal
        isOpen={createModal}
        onClose={() => {
          setcreateModal(false);
        }}
        listFnc={fetchData}
        order_id={params?.id}
        customer_id={data?.order?.customer_obj?.id}
      />
      <DeleteModal
        isOpen={deleteModalShow}
        onClose={() => {
          setdeleteModalShow(false);
        }}
        btnFnc={() => deleteFnc(params?.id)}
      />
      <ShareModal
        isOpen={shareModalShow}
        onClose={() => {
          setShareModalShow(false);
        }}
        moduleName="order"
        modulelabel="order"
      />
      <InvoiceModal
        isOpen={invoiceModalShow}
        onClose={() => {
          setInvoiceModalShow(false);
        }}
        order={data?.order}
        products={data?.products}
      />
      <StandardInvoiceModal
        isOpen={printModalShow}
        onClose={() => {
          setPrintModalShow(false);
        }}
        order={data?.order}
        products={data?.products}
      />
      <DeliveryInvoiceModal
        isOpen={deliveryModalShow}
        onClose={() => {
          setDeliveryModalShow(false);
        }}
        order={data?.order}
        products={data?.products}
      />

      <section className="h-full overflow-auto px-3">
        <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
          <h2 className="text-xl font-semibold capitalize">Orders - view</h2>
          <div className="flex gap-3 items-center">
            <button
              onClick={() => {
                setPrintModalShow(true);
              }}
              className="px-4 py-1 bg-green-600 border-[2px] border-green-600 text-white rounded"
            >
              Print Invoice
            </button>
            <button
              onClick={() => {
                setDeliveryModalShow(true);
              }}
              className="px-4 py-1 bg-green-600 border-[2px] border-green-600 text-white rounded"
            >
              Print Delivery Invoice
            </button>
            <button
              onClick={() => {
                setInvoiceModalShow(true);
              }}
              className="px-4 py-1 bg-green-600 border-[2px] border-green-600 text-white rounded"
            >
              Print Cash Invoice
            </button>

            {permission?.write && (
              <button
                onClick={() => {
                  setShareModalShow(true);
                }}
                className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
              >
                share
              </button>
            )}
            {permission?.write && (
              <Link
                className="px-4 py-2 bg-blue-600 text-white rounded"
                to={`/orders/edit/${params?.id}`}
              >
                edit
              </Link>
            )}
            {permission?.write && (
              <button
                onClick={() => {
                  setdeleteModalShow(true);
                }}
                className="px-4 py-1 bg-errorColor border-[2px] border-errorColor text-white rounded"
              >
                Delete
              </button>
            )}
          </div>
        </div>
        <section className="w-full">
          <section className="flex justify-between w-full">
            <section className="flex flex-wrap gap-5 items-center">
              <div className="px-2">
                <TextView
                  label={"Invoice No"}
                  value={data?.order?.invoice_number}
                />
              </div>
              <div className="px-2">
                <TextView
                  label={"Order Date"}
                  value={data?.order?.order_date}
                />
              </div>
              <div className="px-2">
                <TextView label={"Status"} value={data?.order?.status} />
              </div>
              <div className="px-2">
                <TextView
                  label={"Company"}
                  value={data?.order?.company?.name}
                />
              </div>
              {data?.order?.status === "cancelled" ||
                (data?.order?.status === "refunded" && (
                  <div className="px-2">
                    <TextView
                      label={"Cancellation Reason"}
                      value={data?.order.cancelled_returned_reason}
                    />
                  </div>
                ))}
            </section>
            <section className="flex flex-wrap gap-5 items-center">
              <div className="px-2">
                <TextView
                  label={"Created By"}
                  value={data?.order?.createdBy?.name}
                />
              </div>
              <div className="px-2">
                <TextView
                  label={"Created On"}
                  value={moment(data?.order?.createdAt).format(
                    "DD-MM-YYYY h:mm:ss A"
                  )}
                />
              </div>
              <div className="px-2">
                <TextView
                  label={"Updated On"}
                  value={moment(data?.order?.updatedAt).format(
                    "DD-MM-YYYY h:mm:ss A"
                  )}
                />
              </div>
            </section>
          </section>
          <section className="flex flex-wrap gap-5 items-start">
            <div className="px-2">
              <TextView
                label={"Customer Name"}
                value={data?.order?.customer_obj?.name}
              />
            </div>
            <div className="px-2 my-4">
              <h1 className="text-lightGreyText font-fw_400 text-fs_16 capitalize">
                Delivery Address
              </h1>
              <p className="text-fs_14 font-fw_700">
                {data?.order?.customer_obj?.customer_delivery_addresses?.name}
              </p>
              <p className="text-fs_14">
                {
                  data?.order?.customer_obj?.customer_delivery_addresses
                    ?.address
                }
              </p>
            </div>
            <div className="px-2">
              <TextView
                label={"Transport Vehicle Number"}
                value={data?.order?.transport_vehical_number}
              />
            </div>
            <div className="px-2">
              <TextView
                label={"Billing Type"}
                value={data?.order?.billing_type}
              />
            </div>
            <div className="px-2">
              <TextView
                label={"Payment Mode"}
                value={data?.order?.payment_mode}
              />
            </div>
            <div className="px-2">
              <TextView
                label={"Is Credit"}
                value={data?.order?.is_credit ? "Yes" : "No"}
              />
            </div>
            <div className="px-2">
              <TextView
                label={"Payment Mode"}
                value={data?.order?.payment_mode}
              />
            </div>
          </section>
          <section className="flex items-start justify-between w-full max-w-[60rem]">
            <section className="flex flex-wrap gap-5 items-center">
              <div className="px-2">
                <TextView
                  label={"Payment Duration"}
                  value={data?.order?.payment_duration}
                />
              </div>
              <div className="px-2">
                <TextView
                  label={"Total Invoice Value"}
                  value={data?.order?.total_invoice_value}
                />
              </div>
              <div className="px-2">
                <TextView
                  label={"Total Cash Value"}
                  value={data?.order?.total_cash_amount}
                />
              </div>
              <div className="px-2">
                <TextView
                  label={"Total Taxed Value"}
                  value={data?.order?.total_after_tax}
                />
              </div>
              <div className="px-2">
                <TextView
                  label={"Total GST"}
                  value={
                    data?.order?.cgst + data?.order?.sgst + data?.order?.igst
                  }
                />
              </div>
            </section>
            <section className="pb-5">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize={true}
              >
                <Form>
                  <div className="mt-2">
                    <FormImageField
                      name={"url"}
                      label={"Delivery Photo"}
                      closeShow={false}
                    />
                  </div>
                  {!data?.order?.delivered_photo && (
                    <button
                      type="submit"
                      className="bg-[#10B981] text-white w-full rounded-[5px] py-2"
                    >
                      Save
                    </button>
                  )}
                </Form>
              </Formik>
            </section>
          </section>

          <section className="bg-[#F1F5F9] p-5 rounded-lg">
            <h1 className="text-fs_20 font-fw_500">Payment</h1>
            <section className="flex gap-5">
              <section>
                <section className="flex flex-wrap gap-5 items-center">
                  <div className="px-2">
                    <TextView
                      label={"Payment Pending"}
                      value={data?.paymentObj?.payment_pending ?? "--"}
                    />
                  </div>
                  <div className="px-2">
                    <TextView
                      label={"Taxed Payment Pending"}
                      value={data?.paymentObj?.taxed_payment_pending ?? "--"}
                    />
                  </div>
                  <div className="px-2">
                    <TextView
                      label={"Cash Payment Pending"}
                      value={data?.paymentObj?.cash_payment_pending ?? "--"}
                    />
                  </div>
                </section>
                <section className="flex flex-wrap gap-5 items-center">
                  <div className="px-2">
                    <TextView
                      label={"Payment Received"}
                      value={data?.paymentObj?.payment_received ?? "--"}
                    />
                  </div>

                  <div className="px-2">
                    <TextView
                      label={"Taxed Payment Received"}
                      value={data?.paymentObj?.taxed_payment_received ?? "--"}
                    />
                  </div>
                  <div className="px-2">
                    <TextView
                      label={"Cash Payment Received"}
                      value={data?.paymentObj?.cash_payment_received ?? "--"}
                    />
                  </div>
                </section>
              </section>
              <section>
                {paymentPermission?.write && (
                  <button
                    onClick={() => {
                      setcreateModal(true);
                    }}
                    type="button"
                    className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                  >
                    Add Payment
                  </button>
                )}
              </section>
            </section>
            <table className="w-full text-left rtl:text-right border border-gray-200">
              <thead className="text-gray-700 uppercase bg-[#E5E7EB]">
                <tr>
                  <th
                    scope="col"
                    className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                  >
                    id
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                  >
                    Amount Paid
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                  >
                    Payment Type
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                  >
                    Payment Mode
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                  >
                    Payment Date
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                  >
                    Status
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                  >
                    Cheque Date
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                  >
                    Created By
                  </th>
                  <th
                    scope="col"
                    className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {paymentData?.length > 0 ? (
                  <>
                    {paymentData.map((row, index) => {
                      return (
                        <tr key={index} className="border-t bg-white">
                          <td className="p-1 px-2">{row?.id ?? "--"}</td>
                          <td className="px-4 py-2 max-w-[350px]">
                            <span className="truncate overflow-hidden whitespace-nowrap block">
                              {row?.amount_paid
                                ? "₹ " + row?.amount_paid
                                : "--"}
                            </span>
                          </td>
                          <td className="px-4 py-2 max-w-[350px]">
                            <span className="truncate overflow-hidden whitespace-nowrap block">
                              {row?.payment_mode ?? "--"}
                            </span>
                          </td>
                          <td className="px-4 py-2 max-w-[350px]">
                            <span className="truncate overflow-hidden whitespace-nowrap block">
                              {row?.payment_mode ?? "--"}
                            </span>
                          </td>
                          <td className="px-4 py-2 max-w-[350px]">
                            <span className="truncate overflow-hidden whitespace-nowrap block">
                              {moment(row?.payment_date).format("DD-MM-YYYY")}
                            </span>
                          </td>
                          <td className="px-4 py-2 max-w-[350px]">
                            <span className="truncate overflow-hidden whitespace-nowrap block">
                              {row?.status ?? "--"}
                            </span>
                          </td>
                          <td className="px-4 py-2 max-w-[350px]">
                            <span className="truncate overflow-hidden whitespace-nowrap block">
                              {moment(row?.cheque_date).format("DD-MM-YYYY")}
                            </span>
                          </td>
                          <td className="px-4 py-2 max-w-[350px]">
                            <span className="truncate overflow-hidden whitespace-nowrap block">
                              {row?.createdBy?.name ?? "--"}
                            </span>
                          </td>

                          {row?.assignedTo ? (
                            <td className="py-2 sticky right-0 z-10">
                              <div className="flex gap-3 bg-white px-4">
                                {row?.assignedTo?.read && (
                                  <Link
                                    to={`/payment/view/${row["id"]}`}
                                    className="text-secondary border-[1px] border-secondary px-3 py-1 rounded-md text-fs_14 hover:bg-green-50"
                                  >
                                    View
                                  </Link>
                                )}
                                {row?.assignedTo?.read && (
                                  <Link
                                    to={`/payment/edit/${row["id"]}`}
                                    className="text-primary border-[1px] border-primary px-3 py-1 rounded-md text-fs_14 hover:bg-blue-50"
                                  >
                                    Edit
                                  </Link>
                                )}
                              </div>
                            </td>
                          ) : (
                            <td className="py-2 sticky right-0 z-10">
                              <div className="flex gap-3 bg-white px-4">
                                <Link
                                  to={`/payment/view/${row["id"]}`}
                                  className="text-secondary border-[1px] border-secondary px-3 py-1 rounded-md text-fs_14 hover:bg-green-50"
                                >
                                  View
                                </Link>

                                {paymentPermission?.read && (
                                  <Link
                                    to={`/payment/edit/${row["id"]}`}
                                    className="text-primary border-[1px] border-primary px-3 py-1 rounded-md text-fs_14 hover:bg-blue-50"
                                  >
                                    Edit
                                  </Link>
                                )}
                              </div>
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </>
                ) : (
                  <tr>
                    <td>
                      <p className="text-center my-5">No data found</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </section>

          <section className="bg-[#F1F5F9] p-5 rounded-lg my-5">
            <h1 className="text-fs_20 font-fw_500">Items</h1>
            <section>
              <table className="w-full text-left rtl:text-right ">
                <thead className="text-gray-700 uppercase">
                  <tr>
                    {" "}
                    <th
                      scope="col"
                      className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      #
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      Product
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      Qty
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      Price
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      Billing Amount
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      Cash Amount
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      S-GST
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      C-GST
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      I-GST
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      HSN Code
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      GST Total
                    </th>
                    <th
                      scope="col"
                      className="px-4 py-3 capitalize text-fs_16 font-fw_600"
                    >
                      Cash Total
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data?.products?.length > 0 ? (
                    <>
                      {data?.products.map((row, index) => {
                        return (
                          <tr key={index} className="border-t bg-white">
                            <td className="p-1 px-2">{index + 1}</td>
                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.name ?? "--"}
                              </span>
                            </td>
                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.quantity ?? "--"}
                              </span>
                            </td>
                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.price ?? "--"}
                              </span>
                            </td>
                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.billing_amount ?? "--"}
                              </span>
                            </td>
                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.cash_amount ?? "--"}
                              </span>
                            </td>
                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.sgst_slab ?? "--"}% | {row?.sgst ?? "--"}
                              </span>
                            </td>
                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.cgst_slab ?? "--"}% | {row?.cgst ?? "--"}
                              </span>
                            </td>
                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.igst_slab ?? "--"}% | {row?.igst ?? "--"}
                              </span>
                            </td>
                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.hsn_code ?? "--"}
                              </span>
                            </td>
                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.total_after_tax ?? "--"}
                              </span>
                            </td>
                            <td className="px-4 py-2 max-w-[350px]">
                              <span className="truncate overflow-hidden whitespace-nowrap block">
                                {row?.total_cash_amount ?? "--"}
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </>
                  ) : (
                    <tr>
                      <td>
                        <p className="text-center my-5">No data found</p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </section>
          </section>

          <section className="w-full flex justify-end gap-10">
            <div className="w-full max-w-[20rem] flex flex-col items-end">
              <div className="flex gap-5 text-end">
                <label className="text-end">Final Cash Value (A)</label>
                <div>{data?.order?.total_cash_amount ?? "--"}</div>
              </div>
              <div className="flex gap-5 mt-4">
                <label>Total Invoice Amount (A+B)</label>{" "}
                <div>{data?.order?.total_invoice_value ?? "--"}</div>
              </div>
            </div>
            <div className="w-full max-w-[15rem]">
              <div className="flex gap-5 text-end">
                <label className="text-end">Item Total</label>{" "}
                <div>{data?.order?.total_before_tax ?? "--"}</div>
              </div>
              <div className="flex gap-5 mt-4">
                <label>SGST Amount</label>{" "}
                <div>{data?.order?.sgst ?? "--"}</div>
              </div>
              <div className="flex gap-5 mt-4">
                <label>CGST Amount</label>{" "}
                <div>{data?.order?.cgst ?? "--"}</div>
              </div>
              <div className="flex gap-5 mt-4">
                <label>I GST Amount</label>{" "}
                <div>{data?.order?.igst ?? "--"}</div>
              </div>
              <div className="flex gap-5 mt-4">
                <label>Final Value (B)</label>{" "}
                <div>{data?.order?.total_after_tax ?? "--"}</div>
              </div>
            </div>
          </section>
        </section>
        <CommentsComponent tableName={"orders"} viewId={params?.id} />
        <FileCommentComponent tableName={"orders"} viewId={params?.id} />
      </section>
    </MainLayout>
  );
};

export default ViewOrders;
